import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '@mode/algolia/contract';
import { EmailMemberships, EmailSearchFacade, Emailable, Schedule } from '@mode/shared/schedules/contract';

@Component({
  selector: 'mode-email-subscription',
  templateUrl: './email-subscription.component.html',
  styleUrls: ['./email-subscription.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailSubscriptionComponent implements OnInit {
  @Input() domains: string[] = [];
  @Input() externalSharingEnabled = false;
  @Input() organization = '';
  @Input() memberships: EmailMemberships[] = [];
  @Input() schedule: Schedule = { frequency: 'daily', minute: 0, timeZone: 'UTC', hour: 0 };

  @Output() subscribeEmail = new EventEmitter<Emailable>();
  @Output() removeMember = new EventEmitter<EmailMemberships>();

  searchResults$ = this.emailSearchFacade.searchResults$;

  constructor(private emailSearchFacade: EmailSearchFacade) {}

  ngOnInit() {
    // Initital search results.
    this.emailSearchFacade.searchEmail({
      searchText: '',
      externalSharingEnabled: this.externalSharingEnabled,
      domains: this.domains,
      organization: this.organization,
    });
  }

  search(searchText: string) {
    this.emailSearchFacade.searchEmail({
      searchText,
      externalSharingEnabled: this.externalSharingEnabled,
      domains: this.domains,
      organization: this.organization,
    });
  }

  getFilteredSearchResults(searchResults: User[], subscribedMembers: EmailMemberships[]): User[] {
    return searchResults.filter(
      (eachResult) => !subscribedMembers.some((eachMember) => eachResult.email === eachMember.email)
    );
  }
}
